import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import Link from "@components/Theme/Link/Link"
import {getLink} from "@hooks/PagesData/getLink"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ContactUsHeaderSection.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
}

const ContactUsHeaderSection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<div className={styles.headerContainer}>
						<Link
							className={styles.headerImageBox}
							link={getLink("locationsM")}
						>
							{props.data.preview && (
								<NewResponsiveImage
									imageClassName={styles.headerImage}
									withoutContainer
									{...props.data.preview}
								/>
							)}
						</Link>
						<div className={styles.headerContentBox}>
							<Title content={props.data.title} size={"XL"} />
							<Separator size={16}>
								<Description content={props.data.content} />
							</Separator>
							<ButtonSwitcher
								buttonsList={props.data}
								withoutTarget
							/>
						</div>
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default ContactUsHeaderSection
